import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import { fetchProjects, 
        fetchTotalProjectHours, 
        fetchTotalProjectCost, 
        resetProject } from '../../store/actions/projects/projectsActions';
import { fetchMemberProjects } from '../../store/actions/projects/projectMembersActions';
import { WORK_HOURS, WORK_DAYS, APPROVED} from '../../store/actions/timesheet/timesheetActions';
import { fetchUsers } from '../../store/actions/users/usersActions';
import { Cache } from 'aws-amplify';

import moment from 'moment';
import { MANAGER, PROJECT_SPONSOR } from '../../store/actions/users/usersActions';
import { fixedRounding, toMonetaryFormat } from '../../common/Utilities';


class ProjectMonitoring extends Component {

  constructor(props) {
    super(props);

    this.projectIDs = [];
  }
  
  async componentDidMount() {
    const userId = Cache.getItem('userId');
    this.roleId = Cache.getItem('roleId');
    
    let filters = {is_disabled: 0};
    if (this.roleId === MANAGER) {
      filters.project_manager = userId;
    } else if (this.roleId === PROJECT_SPONSOR) {
      filters.project_sponsor = userId;
      this.props.fetchUsers();
    } 

    this.props.fetchProjects(filters);
    this.props.fetchMemberProjects( userId );
  }

  fetchProjectData = () => {
    const projects = this.props.projects.projects || [];
    if (projects && projects.length) {
      projects.forEach(async project => {
        if (!(project.id in this.projectIDs)) {
          this.projectIDs.push(project.id);
          this.props.fetchTotalProjectHours(project.id);

          if (this.roleId === PROJECT_SPONSOR) {
            this.props.fetchTotalProjectCost(project.id);
          }
        }
      });
    }
  }
  
  renderProjects = () => {
    const projects = this.props.projects.projects;
    const memberProjects = this.props.projects.memberProjects;

    const memberProjectIds = memberProjects && memberProjects.length 
      ? memberProjects.map(memberProject => +memberProject.project_id) : [];

    let projectsList = '';

    if (projects) {
      projectsList = projects.length > 0 ? (
        projects.filter(project => memberProjectIds.includes(+project.id))
          .map((project, key) => {
          const totalProjectHours = this.props.projects.totalProjectHours;
          const budgetHours = +project.budgeted_hours;
          //const completedHours = project.completed_hours;
          let actualTimeCharges = "";
          let remainingBudget = "";
          let runRate = "";
          let remainChargeable = "";
          let netHours = "";

          if (Object.keys(totalProjectHours).length && project.id in totalProjectHours) {
            const projectHours = totalProjectHours[project.id];
            actualTimeCharges = fixedRounding(projectHours
                                  .filter(charge => charge.status === APPROVED)
                                  .map(charge => charge.total_hours)
                                  .reduce((a, b) => +a + +b, 0)) || 0;
            remainingBudget = fixedRounding(budgetHours - actualTimeCharges);

            //see https://trello.com/c/ShwyYJID/7-project-manager-dashboard for formula
            const today = moment();
            const todayWeekStart = today.startOf('week');
            const projectStartWeekStart = moment(project.start_date).startOf('week');
            const projectEndWeekStart = moment(project.end_date).startOf('week');
            const chargedWeeks = moment(todayWeekStart).diff(moment(projectStartWeekStart), 'weeks') + 1;    
            const totalProjectWeeks = moment(projectEndWeekStart).diff(moment(projectStartWeekStart), 'weeks') + 1; 
            const remainingWeeks = totalProjectWeeks - chargedWeeks;

            runRate = chargedWeeks ? fixedRounding(actualTimeCharges / chargedWeeks) : 0;
            if (+runRate !== 0) {
              remainChargeable = fixedRounding(remainingBudget / runRate);
            } else {
              const hoursPerWeek = WORK_HOURS * WORK_DAYS;
              remainChargeable = fixedRounding(remainingBudget / hoursPerWeek);
            }
            const hoursToComplete = runRate * remainingWeeks;
            netHours = fixedRounding(remainingBudget - hoursToComplete);
          }

          let inRange = "";
          if (netHours > 0) {
            inRange = "within-range";
          } else if (netHours < 0) {
            inRange = "out-of-range";
          }
                
          return  (
            <tr key={key}>
              <td>
                <Link to="#" onClick={(e) => {
                  e.preventDefault();
                  this.props.resetProject();
                  this.props.history.push('/projects/view?id=' + project.id);
                }}>
                  {project.project_name}
                </Link>
              </td>
              <td className="align-center">{budgetHours} hours</td>
              <td className="align-center">{actualTimeCharges} hours</td>
              <td className="align-center">{remainingBudget} hours</td>
              <td className="align-center">{runRate} hours / week</td>
              <td className="align-center">{remainChargeable} weeks</td>
              <td className={"align-center " + inRange}>{netHours} hours</td>
            </tr>
          )
        })
       ) : (
         <tr>
           <td colSpan={4}><i>Loading...</i></td>
         </tr>
       )
    }
    else {
      projectsList = <tr><td colSpan={4}><p className="text-danger">No projects found.</p></td></tr>
    }

    return projectsList;
  }
  
  getProjectCosts = () => {
    const projects = this.props.projects.projects;
    const memberProjects = this.props.projects.memberProjects;
  
    const memberProjectIds = memberProjects && memberProjects.length 
      ? memberProjects.map(memberProject => +memberProject.project_id) : [];
  
    let projectsList = '';
  
    if (projects) {
      projectsList = projects.length > 0 ? (
        projects.filter(project => memberProjectIds.includes(+project.id))
          .map((project, key) => {
          const totalProjectCost = this.props.projects.totalProjectCost;
          const budgetCost = +project.fully_loaded_cost;
          let actualTimeCost = "";
          let remainingBudget = "";
          let runRate = "";
          let remainChargeable = "";
          let netCost = "";
  
          if (Object.keys(totalProjectCost).length && project.id in totalProjectCost) {
            const projectHours = totalProjectCost[project.id];
            actualTimeCost = fixedRounding(projectHours.map(charge => charge.actual_cost)
                                            .reduce((a, b) => +a + +b, 0)) || 0;
            remainingBudget = fixedRounding(budgetCost - actualTimeCost);
  
            //see https://trello.com/c/ShwyYJID/7-project-manager-dashboard for formula
            const today = moment();
            const todayWeekStart = today.startOf('week');
            const projectStartWeekStart = moment(project.start_date).startOf('week');
            const projectEndWeekStart = moment(project.end_date).startOf('week');
            const chargedWeeks = moment(todayWeekStart).diff(moment(projectStartWeekStart), 'weeks') + 1;    
            const totalProjectWeeks = moment(projectEndWeekStart).diff(moment(projectStartWeekStart), 'weeks') + 1; 
            const remainingWeeks = totalProjectWeeks - chargedWeeks;
  
            runRate = chargedWeeks ? fixedRounding(actualTimeCost / chargedWeeks) : 0;
            if (+runRate !== 0) {
              remainChargeable = fixedRounding(remainingBudget / runRate);
            } else {
              remainChargeable = fixedRounding(remainingBudget);
            }
            const hoursToComplete = runRate * remainingWeeks;
            netCost = fixedRounding(remainingBudget - hoursToComplete);
          }
  
          let inRange = "";
          if (netCost > 0) {
            inRange = "within-range";
          } else if (netCost < 0) {
            inRange = "out-of-range";
          }
                
          return  (
            <tr key={key}>
              <td>
                <Link to="#" onClick={(e) => {
                  e.preventDefault();
                  this.props.resetProject();
                  this.props.history.push('/projects/view?id=' + project.id);
                }}>
                  {project.project_name}
                </Link>
              </td>
              <td className="align-center">₱{toMonetaryFormat(budgetCost)}</td>
              <td className="align-center">₱{toMonetaryFormat(actualTimeCost)}</td>
              <td className="align-center">₱{toMonetaryFormat(remainingBudget)}</td>
              <td className="align-center">₱{toMonetaryFormat(runRate)} / week</td>
              <td className="align-center">₱{toMonetaryFormat(remainChargeable)}</td>
              <td className={"align-center " + inRange}>₱{toMonetaryFormat(netCost)}</td>
            </tr>
          )
        })
       ) : (
         <tr>
           <td colSpan={4}><i>Loading...</i></td>
         </tr>
       )
    }
    else {
      projectsList = <tr><td colSpan={4}><p className="text-danger">No projects found.</p></td></tr>
    }
  
    return projectsList;
  }

  renderProjectCosts = () => {

    if (this.roleId === PROJECT_SPONSOR) {
      return (<Table>
        <thead>
          <tr>
            <th>Project Name</th>
            <th className="align-center">Original Budgeted Cost</th>
            <th className="align-center">Actual Charges</th>
            <th className="align-center">Remaining Budget</th>
            <th className="align-center">Project Run Rate</th>
            <th className="align-center">Remaining Chargeable Cost</th>
            <th className="align-center">Project Cost Surplus / Deficit</th>
          </tr>
        </thead>
        <tbody>
          { this.getProjectCosts() }
        </tbody>
      
      </Table>)
    } 
    
    return '';
    
  }

  render() {

    if (!this.projectIDs.length) {
      this.fetchProjectData();
    }

    return (
      <>
        <Table>
          <thead>
            <tr>
              <th>Project Name</th>
              <th className="align-center">Original Budgeted Hours</th>
              <th className="align-center">Actual Time Charges</th>
              <th className="align-center">Remaining Budgeted Hours</th>
              <th className="align-center">Project Run Rate</th>
              <th className="align-center">Remaining Chargeable</th>
              <th className="align-center">Project Hours Surplus / Deficit</th>
            </tr>
          </thead>
          <tbody>
            { this.renderProjects() }
          </tbody>
        </Table>
        { this.renderProjectCosts() }
        <hr/>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  projects: state.projects,
  users: state.users
})

const mapDispatchToProps = (dispatch) => {
  return {
    fetchProjects: (...args) => dispatch(fetchProjects(...args)),
    fetchTotalProjectHours: (...args) => dispatch(fetchTotalProjectHours(...args)),
    fetchTotalProjectCost: (...args) => dispatch(fetchTotalProjectCost(...args)),
    resetProject: (...args) => dispatch(resetProject(...args)),
    fetchMemberProjects: (...args) => dispatch(fetchMemberProjects(...args)),
    fetchUsers: (...args) => dispatch(fetchUsers(...args)),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProjectMonitoring))